import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import LogoutService from "../../services/LogoutService";
import localDataStorage from "../../store/localDataStorage";
import { resetMasterState, setIsAuthenticated } from "../../store/reduxMasterSlice";
import { Images } from "../../utils/Images";
import { URL } from '../../services/URL';
import "./ProfileComponent.css";

const ProfileComponent = (props) => {
    const [open, setOpen] = useState(false);

    const containerRef = useRef(null);
    const profile = useSelector((s) => s.reduxMaster.masterArray.UserLoginInfo);
    const profilePicture = useSelector((s) => s.reduxMaster.masterArray.UserProfilePic);

    const dispatch = useDispatch();

    // Close on outside click
    useEffect(() => {
        const handler = (e) => {
            if (containerRef.current && !containerRef.current.contains(e.target))
                setOpen(false);
        };
        document.addEventListener("mousedown", handler);
        return () => document.removeEventListener("mousedown", handler);
    }, []);

    const navigate = useNavigate();

    // Function added by Akshay
    const handleOnClick = () => {
        navigate("/profile");
        setOpen(false);
    }

    const handleLogout = async () => {
        props.isLoading(true);

        await LogoutService(profile.UserName);

        // if (response.status) {
        dispatch(resetMasterState());
        localDataStorage.removeLocalStorage();

        // Dashboard widgets are cached per user in sessionStorage for fast reloads;
        // clear it on logout so the next login never renders a stale user's layout.
        Object.keys(sessionStorage)
            .filter((key) => key.startsWith("dashboardLayoutCache_"))
            .forEach((key) => sessionStorage.removeItem(key));

        navigate("/login");
        // } else {
        //     alert(response.message);
        // }
    };

    const getInitials = (userName = '') => {
        const parts = userName.trim().split(/\s+/).filter(Boolean);
        if (!parts.length) return '';

        if (parts.length > 1) {
            return (parts[0][0] + parts[1][0]).toUpperCase();
        }

        const word = parts[0];
        return (word[0] + (word[1] || '')).toUpperCase();
    };

    return (
        <div className="dd-profile-container" ref={containerRef}>
            {/* Wrapper */}
            <div className={`dd-profile-wrapper ` + (open && "open")} onClick={() => setOpen((prev) => !prev)}>
                {profilePicture?.ConnectingPath
                    ? <img src={`${URL()}${profilePicture.ConnectingPath}`} style={{ width: '40px', height: '40px', borderRadius: '50%', objectFit: 'contain' }} />
                    : <div className="profile-avatar-header">
                        {getInitials(profile?.UserName)}
                    </div>}

                {/* Trigger button */}
                <div className="dd-profile-trigger" aria-haspopup="listbox" aria-expanded={open}>

                    {/* Left Content */}
                    <div className="dd-profile-email-span">
                        <div style={{ fontSize: "16px", fontWeight: "400" }}> {profile.UserName} </div>

                        {profile?.UserName && (<span>{profile.EMail} </span>)}
                    </div>

                    {/* Right Arrow */}
                    <svg className="dd-profile-arrow" viewBox="0 0 10 6" width="12" height="6" aria-hidden="true" >
                        <path d="M1 1l4 4 4-4" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" fill="none" />
                    </svg>
                </div>
            </div>

            {/* Dropdown list */}
            {open && (
                <div className="dd-profile-list" role="listbox">
                    <div className={`dd-option-item`} onClick={handleOnClick}>
                        <img src={Images.profile} alt="profile" /> Profile
                    </div>
                    {/* <div className={`dd-option-item`} onClick={() => navigate("/settings")}>
                        <img src={Images.setting} alt="setting" /> Setting
                    </div> */}
                    <div className={`dd-option-item`} onClick={handleLogout}>
                        <img src={Images.logout} alt="logout" /> Logout
                    </div>
                </div>
            )}
        </div>
    );
};

export default ProfileComponent;
